import React from 'react';

const DriveTimeTooltipContent: React.FC = () => {
  return (
    <div className="tooltip-content">
      <h4>Drive Time Query Builder</h4>
      <p>Create queries to analyze drive times between locations across different time periods</p>

      <div>
        <p>
          <strong>Date Range:</strong>
        </p>
        <p className="date-range">Select the period for analysis.</p>
        <p>Real data available for:</p>
        <ul>
          <li>November 2024</li>
          <li>October 2025</li>
          <li>November 2025</li>
          <li>March 2026</li>
          <li>April 2026</li>
        </ul>
      </div>

      <div>
        <p>
          <strong>Time Interval:</strong>
        </p>
        <p>Analysis granularity - smaller intervals provide more detailed insights but require more data points.</p>
      </div>

      <div>
        <p>
          <strong>Locations:</strong>
        </p>
        <p>Enter pickup and dropoff addresses. Use the + button to save locations or create new ones.</p>
      </div>
    </div>
  );
};

export default DriveTimeTooltipContent;
